import React from "react";

// BSU uses Zendesk so this is just a fallback
export default function HelpContent() {
    return (
        <div>
            For help, contact{" "}
            <a href="mailto:cdraney@csi.edu">
                cdraney@csi.edu
            </a>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/siteConfig/sites/csi/siteComponents/helpContent.js